import { render, staticRenderFns } from "./EditProfileWorkDetails.vue?vue&type=template&id=92096b0e&scoped=true"
import script from "./EditProfileWorkDetails.vue?vue&type=script&lang=js"
export * from "./EditProfileWorkDetails.vue?vue&type=script&lang=js"
import style0 from "./EditProfileWorkDetails.vue?vue&type=style&index=0&id=92096b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92096b0e",
  null
  
)

export default component.exports